const STORAGE_KEY = "NIKSHAY_loggedinUserdetails";

export const getNikshayUser = () => {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;

        return JSON.parse(raw);
    } catch (error) {
        console.error("Invalid Nikshay user data in storage", error);
        return null;
    }
};

export const getNikshayUsername = () => {
    const user = getNikshayUser();
    return user?.username || "";
};
